import { render, staticRenderFns } from "./ArticleStockTable.vue?vue&type=template&id=601f7be8&scoped=true&"
import script from "./ArticleStockTable.vue?vue&type=script&lang=js&"
export * from "./ArticleStockTable.vue?vue&type=script&lang=js&"
import style0 from "./ArticleStockTable.vue?vue&type=style&index=0&id=601f7be8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601f7be8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDataTable,VToolbar,VToolbarTitle})
